export const DateUtil = {
  getDateStr: (dateObject) => {
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth() + 1;

    const date = dateObject.getDate();

    return `${year}-${month >= 10 ? month : `0${month}`}-${date >= 10 ? date : `0${date}`}`;
  },

  getTimeStr: (dateObject) => {
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth() + 1;
    const date = dateObject.getDate();

    const hour = dateObject.getHours();
    const minite = dateObject.getMinutes();
    const second = dateObject.getSeconds();

    return `${year}-${month >= 10 ? month : `0${month}`}-${date >= 10 ? date : `0${date}`} ${
      hour >= 10 ? hour : `0${hour}`
    }:${minite >= 10 ? minite : `0${minite}`}:${second >= 10 ? second : `0${second}`}`;
  },
  getTodayDateStr: () => {
    const nowDate = new Date();
    return DateUtil.getDateStr(nowDate);
  },
  getNowTimeStr: () => DateUtil.getTimeStr(new Date()),
  getWeekAgoDateStr: () => {
    const nowDate = new Date();
    nowDate.setDate(nowDate.getDate() - 6);

    return DateUtil.getDateStr(nowDate);
  },
};
